export default {
  get (VueApp, params, callback) {
    VueApp.$sdk.get(VueApp, '/1.1/me/credits', params, res => {
      if (!res.error) {
        VueApp.$store.commit('setCredits', parseFloat(res.credits.toFixed(2)))
      }
      callback(res)
    }, '')
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/_credits.js